export const ALL_ROLES = Object.freeze(["admin", "analyst", "viewer"]);
export const SCOUTING_ROLES = Object.freeze(["admin", "analyst"]);
export const CUSTOM_REPORT_ROLES = ALL_ROLES;
export const PLAYFINDER_ROLES = Object.freeze(["admin", "analyst"]);

export function hasAnyRole(role, allowedRoles) {
  return allowedRoles.includes(role);
}

export function canAccessScouting(role) {
  return hasAnyRole(role, SCOUTING_ROLES);
}

export function canViewGameIds(role) {
  return hasAnyRole(role, SCOUTING_ROLES);
}

export function canAccessCustomReport(role) {
  return hasAnyRole(role, CUSTOM_REPORT_ROLES);
}

export function canAccessPlayFinder(role) {
  return hasAnyRole(role, PLAYFINDER_ROLES);
}
